'use strict';

angular
  .module('ClinicApp')
  .controller('previewMessageModal', function($scope, $modalInstance, content) {
    $scope.content = content;
    $scope.validTimeSlots = _.filter($scope.content.timeSlots, function(slot) {
      return slot.date !== '';
    });

    $scope.validTimeSlotsFormatted = _.map($scope.validTimeSlots, function(slot) {
      return slot ? slot.time.label + ' on ' + moment(slot.date).format('dddd, MMMM Do YYYY') : null;
    });

    $scope.showOptionalMessage = !!content.optionalMessage.message;
    $scope.showTimeSlotsMessage = $scope.validTimeSlots.length > 0;
    $scope.showErrorMessage = !$scope.validTimeSlots || $scope.validTimeSlots.length < 1;

    $scope.closeModal = function() {
      $modalInstance.close();
    };

  });
